import {
  RAW_DATA_TAB_SET_BEFORE_RANGE_DATE,
  RAW_DATA_TAB_LOAD_DATA_RESULT,
  RAW_DATA_TAB_SET_FILTERS,
  RAW_DATA_TAB_LOAD_DATA
} from 'Redux/actionTypes';

export const rawDataTabGetData = (deviceId, method, filters) => ({
  type: RAW_DATA_TAB_LOAD_DATA,
  payload: { deviceId, method, filters }
});

export const rawDataTabGetDataResult = (data) => ({
  type: RAW_DATA_TAB_LOAD_DATA_RESULT,
  payload: data
});

export const rawDataTabSetFilters = (data) => ({
  type: RAW_DATA_TAB_SET_FILTERS,
  payload: data
});

export const rawDataTabSetBeforeRangeDate = (data) => ({
  type: RAW_DATA_TAB_SET_BEFORE_RANGE_DATE,
  payload: data
});